import React from 'react';
import { Icon, Popconfirm } from 'antd'
const  moment = require('moment');

class Log extends React.Component {

  render() {

    const { data, color } = this.props


    const styles = {
      box: {
        backgroundColor: 'white',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.16)',
        borderRadius: 10,
        padding: 20,
        minHeight: 232
      },
      title: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 16,
        marginBottom: 0
      },
      entry: {
        fontFamily: 'Helvetica Neue',
        color: color,
        fontSize: 16
      },
      date: {
        padding: '0px 20px',
        backgroundColor: color,
        borderRadius: 10,
        color: 'white',
        fontFamily: 'Arial Rounded MT Bold',
        fontSize: 12,
        position: 'absolute',
        right: 30,
        top: 30
      },
      deleteIcon: {
        position: 'absolute',
        right: 30,
        bottom: 30,
        fontSize: 26,
        color: color
      },
      editIcon: {
        position: 'absolute',
        right: 70,
        bottom: 30,
        fontSize: 26,
        color: color
      }
    }
    const { t } = this.props
    return (
      <div id='logBox' style={styles.box}>
        <div onClick={() => this.props.openGallery()}>
          <h3 style={styles.title}>{t('Class')}</h3>
          <p style={styles.entry}>{data.className}</p>
          <h3 style={styles.title}>{t('Title of Work')}</h3>
          <p style={styles.entry}>{data.title}</p>
          <h3 style={styles.title}>{t('Level of Skill')}</h3>
          <p style={styles.entry}>{t(data.skill)}</p>
          <div style={styles.date}>{moment(data.date).format('DD-MM-YY')}</div>
          <div style={styles.attachment}></div>
        </div>
        {this.props.editButtons &&
          <div>
            <Popconfirm title={t('Do you want to delete this log?')} onConfirm={() => this.props.deleteLog()} okText={t("Yes")} cancelText={t("No")}>
              <Icon style={styles.deleteIcon} type="delete" />
            </Popconfirm>
            <Icon style={styles.editIcon} onClick={() => this.props.editLog()} type="edit" />
          </div>
        }
      </div>
    )
  }
}

export default Log;



// WEBPACK FOOTER //
// ./src/components/Log/index.jsx